import { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { useAtom } from 'jotai'
import { useIsClient } from '@/hooks'
import { Columns } from '@/components'
import { projectAtom } from '@/stores'

const Scene = () => {
    const [projects] = useAtom(projectAtom)
    const isClient = useIsClient()

    if (!projects || !isClient) return null

    return (
        <Canvas
            gl={{ antialias: true }}
            dpr={[1, 2]}
            camera={{ near: 1, far: 10 }}
        >
            <Suspense fallback={null}>
                <Columns />
            </Suspense>
        </Canvas>
    )
}

export const CanvasContainer = () => {
    const isClient = useIsClient()

    if (!isClient) {
        return <div className="w-full h-screen overflow-hidden" />
    }

    return (
        <div className="w-full h-screen overflow-hidden">
            <Scene />
        </div>
    )
}
